import { Component, ViewModel, ObservableArray, View, ObservableArrayChangeListenner, DelegatedObservableArrayChangeListenner } from "binder";
import { getAsBoolean } from "../utilities";
import { LineItemViewModel } from "./lineItem/lineItem-viewModel";
import  { TreeView } from "./tree-view"

export class TreeViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.internalItems = ObservableArray.create<LineItemViewModel>();
        this.openall = false;
        this.items = ObservableArray.create<ViewModel>();
        this.itemsMap = new WeakMap<ViewModel,LineItemViewModel>();
        this.searchText = "";
    }

    GetDefaultView(): View <ViewModel> {
        return new TreeView();
    }
    public getTypeId(): string {
        return "VM-995EFFE7-1754-4BA7-B0DF-EA54EC9B62E3"
    }
    private changeListenner : ObservableArrayChangeListenner;
    
    public set items(v: ObservableArray<ViewModel>) { 
        if(this.items!=null){
            this.items.removeChangeListenner(this.changeListenner);
        }
        this._items = v; 
        if(this.items!=null){
            let listenner = new DelegatedObservableArrayChangeListenner(this,arr=>this.listChanged());
            this.items.addChangeListenner(listenner);
            this.listChanged();
        }
    } public get items(): ObservableArray<ViewModel> { return this._items;} private _items: ObservableArray<ViewModel>;
    public set searchText(v: string) { 
        this._searchText = v; 
        this.applyFiltering(); 
    } public get searchText(): string { return this._searchText;} private _searchText: string;
    public set filterevaluator(v: ITreeFilter) { this._filterEvaluator = v; } public get filterevaluator(): ITreeFilter { return this._filterEvaluator;} private _filterEvaluator: ITreeFilter;
    public set allowfiltering(v: boolean) { this._allowFiltering = v; } public get allowfiltering(): boolean { return this._allowFiltering;} private _allowFiltering: boolean;
    
    public set openall(v: boolean) { 
        this._openall = getAsBoolean(v); 
        if(this.openall==true)
            this.internalItems.forEach(x=>{x.openall=true;})
    } public get openall(): boolean { return this._openall;} private _openall: boolean;
    
    public set childlistpath(v: string) { 
        this._childlistpath = v; 
        this.listChanged();
    } public get childlistpath(): string { return this._childlistpath;} private _childlistpath: string;
    public set template(v: Node) { this._template = v; } public get template(): Node { return this._template;} private _template: Node;
    public set internalItems(v: ObservableArray<LineItemViewModel>) { this._internalItems = v; } public get internalItems(): ObservableArray<LineItemViewModel> { return this._internalItems;} private _internalItems: ObservableArray<LineItemViewModel>;
    
    private itemsMap:WeakMap<ViewModel,LineItemViewModel>;

    listChanged(){
        if(this.childlistpath && this.internalItems && this.items)
            this.internalItems.update(...this.items.map(x=>{
                if(this.itemsMap.has(x)==false){
                    let newContainer = new LineItemViewModel(this);
                    newContainer.parentLineItem = null;
                    newContainer.template = this.template;
                    newContainer.element = x;
                    newContainer.childPath = this.childlistpath;
                    newContainer.openall = this.openall;
                    newContainer.isOpen = this.openall;
                    this.itemsMap.set(x,newContainer);
                }
                return this.itemsMap.get(x);
            }));
        this.applyFiltering();
    }   

    applyFiltering(){
        
        let qUnfilter : LineItemViewModel[]=[];
        qUnfilter.push(...this.internalItems);
        while(qUnfilter.length>0){
            let element = qUnfilter.shift();
            element.isFiltered = false;
            qUnfilter.push(...element.internalItems);
        }

        if(this.filterevaluator==null || this.allowfiltering==false)
            return;

        let q : LineItemViewModel[]=[];
        q.push(...this.internalItems);
        while(q.length>0){
            let element:LineItemViewModel = q.shift();
            let result = this.filterevaluator.filter(element.element,this.searchText)
            if(result==false){
                q.push(...element.internalItems)
                element.isFiltered = true;
            }else{
                let p = element;
                while(p!=null){
                    p.isFiltered = false;
                    p=p.parentLineItem;
                }
            }
        }
    }
}

export interface ITreeFilter{
    filter(item:any,searchText:string):boolean;
}